import { getAirports } from '../../shared/data-services/airport-service';
import { getUserByAirport, updateState } from '../../shared/data-services/talmaid-service';

export async function getAllAirports (companyId){
    const data = await getAirports(companyId);
    return data;
};

export async function getUsersByAirport(AirportId){
    const data = await getUserByAirport(AirportId);
    return data;
}

export async function UpdateState(UserId, State, UserDNI){
    const data = await updateState(UserId, State, UserDNI);
    return data;
}